<template>
  <div class="orderGoods">
    <div class="total">共{{ cartInfo.length }}件商品</div>
    <div class="goodWrapper">
      <div
        class="item acea-row row-between-wrapper"
        v-for="(cart,index) in cartInfo"
        :key="cart.id"
      >
        <div class=" ">
       {{ index+1 }}
        </div>
        <div class="text" @click="showInputModal(cart.id,cart.sl)">
          <div class="acea-row row-between-wrapper">
            <div class="name line1">{{ cart.goods_name }}</div>
            <div class="num">x {{ cart.sl }}</div>
          </div>
          <div class="attr line1" v-if="cart.title">
            {{ cart.title }}
          </div>
 
        </div>
	 
	
	 <div v-if="edit==true" class="bnt bg-color-red" style="padding: 5px 5px;color:white" @click="shanchu(cart.id)">删除</div> 
	  
      </div>
	  	<!-- 弹窗组件 -->
    <div v-if="showModal" class="modal" @click.self="closeModal">
      <div class="modal-content">
        <input 
          type="number" ref="modalInput" 
          v-model.number="tempValue"
          placeholder="请输入数量"
          min="0"
          @keyup.enter="confirmInput"   
        >
	 
        <div class="actions">
          <button @click="closeModal">取消</button>
          <button @click="confirmInput"  >确定</button>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import { editgoods } from "@api/order";
import Modal from '../components/input/input'
import {
  shanchugoodsHandle
} from "@libs/order";
// 引用全局VUE中的接口
import Vue from 'vue';
export default {
 components: { Modal },
  name: "OrderGoods",
  props: {
     
    cartInfo: {
      type: Array,
      default: () => []
    },
	edit:{
	default:false
	}
	 

  },
  data: function() {
    return {
	  showModal: false,      // 控制弹窗显示
      tempValue: 0 ,          // 临时存储输入值
	id: '' 
	
	};
  },
  mounted: function() {},
  methods: {

  shanchu(id){
  console.log(id);
    shanchugoodsHandle(id)
        .then(() => {
          //location.reload()
		    this.$emit('custom-event');
        })
        .catch(() => {
           
        });
  
  
  
  },
  // 显示输入弹窗
    showInputModal(id,sl) {
	if(this.edit==true){
	
 
	
	//console.log(id+'/'+sl);
      this.showModal = true;
      this.tempValue = sl; // 初始化输入值为当前数量
      this.id = id; 
      // 自动聚焦输入框
      this.$nextTick(() => {
 
 
        this.$refs.modalInput.focus();
		  
        this.$refs.modalInput.select(); // 自动选中文本方便修改
		 
      });
	  	}
    },
    
    // 关闭弹窗
    closeModal() {
      this.showModal = false;
    },
    
    // 确认输入
    confirmInput() {
      const newValue = Number(this.tempValue);
 
	  
      // 输入验证
      if (isNaN(newValue) || newValue < 0) {
        alert('请输入有效的数量');
        return;
      }
      
      // 更新商品数量
      if (newValue > 0) {
	   
			
			
			  editgoods(this.id,newValue)
        .then((res) => {
           console.log(res);
		    this.$emit('custom-event');
		   
			   
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
			
    
      } else {
      
	  
      }
      
      this.closeModal();
    },
  
  
  }
};
</script>

<style lang="less"  scoped>
@import "../common/less/index.less";
.cartcontrol{
	font-size: 0;
	.cart-decrease{
		display:inline-block;
		padding:6px;
		transition:all 0.4s linear;
		transform:translate3D(0,0,0);
	    .inner{
	    	display:inline-block;
	    	line-height:24px;
			font-size: 24px;
			color:rgba(0,160,220);
			transform:rotate(0);
			transition:all 0.4s linear;
	    }
		&.move-enter,&.move-leave-to{
			opacity:0;
			transform:translate3D(24px,0,0);
			.inner{
				transform:rotate(180deg);
			}
		}	    
	}
	.cart-count{
		display:inline-block;
		font-size: 10px;
		vertical-align:top;
		width:22px;
		padding-top: 6px;
		color:#93999f;
		line-height:24px;
		text-align: center;
	}
	.cart-add{
		display:inline-block;
		padding:6px;
		line-height:24px;
		font-size: 24px;
		color:rgba(0,160,220)
	}
}
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* 确保在顶层 */
}

.modal-content {
  background: white;
  padding: 25px; /* 增加内边距 */
  border-radius: 10px; /* 圆角增大 */
  width: 320px; /* 加宽 */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3); /* 添加阴影 */
  
  input {
    width: 100%;
    padding: 12px;
    font-size: 16px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-sizing: border-box;
    
    &:focus {
      border-color: rgba(0, 160, 220);
      outline: none;
    }
  }
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px; /* 增大间距 */
  margin-top: 20px; /* 增加上边距 */
  
  button {
    padding: 10px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
	line-height:20px;
    &:first-child {
      background: #f0f0f0;
      
      &:hover {
        background: #e0e0e0;
      }
    }
    
    &:last-child {
      background: rgba(0, 160, 220);
      color: white;
      
      &:hover {
        background: rgba(0, 140, 200);
      }
    }
  }
}
</style>